import { ChangeDetectionStrategy, Component, ContentChild, TemplateRef } from '@angular/core';
import { NgTemplateOutlet, NgIf } from '@angular/common';

@Component({
    selector: 'sh-content-context-layout',
    templateUrl: './content-context-layout.component.html',
    styleUrl: './content-context-layout.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgTemplateOutlet, NgIf]
})
export class ContentContextLayoutComponent {
    @ContentChild('content') content: TemplateRef<any>;
    @ContentChild('context') context: TemplateRef<any>;
}
